import { STATUS_OPTIONS } from './eventsFiltersConfig';

export const buildRefundsFilterGroups = (filterOptions = {}) => [
  {
    id: 'refund_details',
    label: 'Refund Details',
    filters: [
      {
        id: 'state',
        label: 'Status',
        type: 'checkbox',
        options: [
          { value: 'reviewing', label: 'Reviewing' },
          { value: 'ach_processing', label: 'ACH Processing' },
          { value: 'succeeded', label: 'Succeeded' },
          { value: 'failed', label: 'Failed' },
        ],
      },
      {
        id: 'reason',
        label: 'Reason',
        type: 'checkbox',
        options: [
          { value: 'Covid-19', label: 'Covid-19' },
          { value: 'Dissatisfied with event', label: 'Dissatisfied with event' },
          { value: 'Duplicate order', label: 'Duplicate order' },
          { value: 'Event cancelled or postponed', label: 'Event cancelled or postponed' },
          { value: 'Forgot to use discount or promo code', label: 'Forgot to use discount or promo code' },
          { value: 'No longer able to attend', label: 'No longer able to attend' },
          { value: 'Other reason not listed', label: 'Other reason not listed' },
          { value: 'Purchased the wrong ticket', label: 'Purchased the wrong ticket' },
          { value: 'Refund within organizer policy', label: 'Refund within organizer policy' },
          { value: 'Seat removed from the seat map', label: 'Seat removed from the seat map' },
          { value: 'Ticket price or taxes changed', label: 'Ticket price or taxes changed' },
        ],
      },
      {
        id: 'refund_type',
        label: 'Type',
        type: 'checkbox',
        options: [
          { value: 'single_order', label: 'Single Order' },
          { value: 'multiple_order', label: 'Multiple Order' },
          { value: 'multiple_face_value', label: 'Face Value' },
        ],
      },
    ],
  },
  {
    id: 'event',
    label: 'Event',
    filters: [
      {
        id: 'calendar_classification',
        label: 'Event Status',
        type: 'checkbox',
        options: STATUS_OPTIONS,
      },
      {
        id: 'calendar_event_id',
        label: 'Event',
        type: 'checkbox',
        options: (filterOptions.event_options || []).map(o => ({
          value: String(o.value),
          label: o.label,
        })),
      },
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({
          value: String(o.value),
          label: o.label,
        })),
      },
    ],
  },
];
